(function($, undefined) {

	/**
	 * @author Radek Šerý
	 *
	 * Inicializace collapsable elementů, týká se pouze těch, které mají class="js-collapsable-legacy"
	 */
	$.nette.ext('collapsable', {
		init: function() {
			var snippetsExt = $.nette.ext('snippets');
			var ext = this;

			snippetsExt.after(function($el) {
				ext.init.call(ext, $el);
			});

			this.init($(document));

		},
		success: function() {
			window.$closeThisStuffOnHtmlClickOrTap.caDropdown = $('.js-collapsable-dropdown');
		}
	}, {
		selector: [
			'.js-collapsable-legacy:not(.js-collapsable-accordion .js-collapsable-legacy)',
			'.js-collapsable-dropdown',
			'.js-slide-collapsable', '.js-collapsable-outer'
		],
		optionsPerSelector: {
			'.js-slide-collapsable': {
				fx: 'slide',
				fxDuration: 300
			},
			'.js-collapsable-outer': {
				control:          '.ca-control-outer',
				box:              '.ca-box-outer',

				classNames: {
					expanded:        'ca-expanded-outer',
					collapsed:       'ca-collapsed-outer',
					defaultExpanded: 'ca-default-expanded-outer',
					extLinkActive:   'ca-ext-active-outer'
				}
			}
		},
		init: function ($el) {
			var l = this.selector.length;

			for (var i = 0; i < l; i++) {
				$el
					.find(this.selector[i])
					.on('expand.collapsable collapse.collapsable', function (e) {
						e.stopPropagation(); // kvůli zanoření více collapsable do sebe je potřeba, jinak se bude vyvolávat callback i na $headerTools
						window.dispatchEvent(new Event('resize')) // Dirty fix for Seznam maps tiles rendering
					})
					.collapsable(this.optionsPerSelector[this.selector[i]] || {});

			}
			$el.find('.js-collapsable-accordion').each(function() {
				var $this = $(this);
				var $extLink = $this.find('.js-collapsable-ext-link');
				var collapsableAll = typeof $this.data('collapsable-all') !== 'undefined' ? $this.data('collapsable-all') : true;
				var collapsableAllFalse = typeof $this.data('collapsable-all-false') !== 'undefined' ? parseInt($this.data('collapsable-all-false')) : Infinity;

				$this.find('.js-collapsable-legacy')
					.on('collapse.collapsable', function (e) {
						if (cssWidth > collapsableAllFalse){
							var ca = $(this).data('collapsable');
							if (! ca || ! ca.parent.promiseOpen) {
								e.preventDefault();
							}
						}
						$this.removeClass('js-collapsable-accordion--expand');
					})
					.on('expand.collapsable', function(e) {

						$this.addClass('js-collapsable-accordion--expand');
					})
					.collapsable({
						extLinks: {
							selector: $extLink,
							preventDefault: true
						},
						accordion: true,
						collapsableAll: collapsableAll
					});
			});
		}
	});

})(jQuery);
